import createId from './create-id.js'

export {
  createId
}
